export const enum NDAKCECHECK_PZN {
	VYPNUTO = 0,
	S_UPOZORNENIM = 1,
	BEZ_UPOZORNENIA = 2,
}

export const loggedUser = {
	Jmeno: null as string | null,
	Prijmeni: null as string | null,
	UzivatelData: {
		ProvozovnaId: null as number | null,
		StrednaklOzn: null as number | null,
		LanguageId: null as number | null,
		VyrobekvozOzn: null as string | null,
		SkladnvOzn: null as number | null,
		RekltxtId: null as number | null,
		PokladnaId: null as number | null,
		SkladOzn: null as string | null,
		VyrobekndOzn: null as string | null,
		OzakazkaPzn: null as number | null,
		ZakazkaDruh: null as string | null,
		MenaId: null as number | null,
		BarvaEdit: null as number | null,
		DashbstartPrp: null as boolean | null,
		DmscVinFormatPrp: null as boolean | null,
		ExtodpisZobr: null as number | null,
		GridBcolorAttention: null as number | null,
		GridBcolorCritical: null as number | null,
		GridBcolorInactive: null as number | null,
		GridBcolorReady: null as number | null,
		GridBcolorUrgent: null as number | null,
		GridFcolorUnchecked: null as number | null,
		GridSirka: null as number | null,
		GridVyska: null as number | null,
		IconsSize: null as number | null,
		JfndZpracrezimPzn: null as number | null,
		Login: null as string | null,
		MechanikId: null as number | null,
		MnrsubstrnvRez: null as boolean | null,
		MnrsubstrovRez: null as boolean | null,
		MnrsubstrsmRez: null as boolean | null,
		OknoPozice: null as number | null,
		OknoVelikost: null as number | null,
		PerskartaId: null as string | null,
		PracovnikId: null as number | null,
		PujcovnaId: null as number | null,
		PultndzrychPrp: null as boolean | null,
		RekltxtIdNv: null as number | null,
		SkladnvOznKonsign: null as number | null,
		SkladostOzn: null as number | null,
		SkladovOzn: null as number | null,
		SkladpneuOzn: null as number | null,
		SpzsubstrnvRez: null as boolean | null,
		SpzsubstrovRez: null as boolean | null,
		SpzsubstrsmRez: null as boolean | null,
		StatusbarZobrPrp: null as boolean | null,
		SuperuzivPrp: null as boolean | null,
		ToolbarIcons: null as string | null,
		ToolbarpozPzn: null as boolean | null,
		TympracId: null as number | null,
		TympracIdPt: null as number | null,
		UctoosnovaId: null as number | null,
		VinsubstrnvRez: null as boolean | null,
		VinsubstrovRez: null as boolean | null,
		VinsubstrsmRez: null as boolean | null,
		VyrobekndVydejPrp: null as boolean | null,
		ZakazkaDruhEshop: null as string | null,
		ZakazkaDruhPz: null as string | null,
		ZakazkaLeaszakaznikPrp: null as boolean | null,
		ZakazkaPojistovnaPrp: null as boolean | null,
		ZakazkaPripravaPrp: null as boolean | null,
		ZakazmojePrp: null as boolean | null,
		ZakazzobrPrp: null as boolean | null,
		ZaznamId: null as number | null,
		ZlTextvoln: null as string | null,
	},
	PracovnikData: {
		CmrozvrhId: null as number | null,
		DzcXcz: null as string | null,
		EMailAdresa: null as string | null,
		EmiseOsvedc: null as string | null,
		EmiseOsvedcVznet: null as string | null,
		Jmeno: null as string | null,
		Memo: null as string | null,
		Obec: null as string | null,
		OsobniCis: null as string | null,
		OzakazkobjPrp: null as boolean | null,
		Oznam: null as string | null,
		PersoncardId: null as string | null,
		PersoncardvydPrp: null as boolean | null,
		PracovnikId: null as number | null,
		PracovnikOzn: null as string | null,
		Prijmeni: null as string | null,
		ProduktPrp: null as boolean | null,
		ProduktPrpt: null as boolean | null,
		ProvozovnaId: null as number | null,
		PscNr: null as string | null,
		Rodnecislo: null as string | null,
		StrednaklOzn: null as number | null,
		TankomatNr: null as string | null,
		TankovaniPrp: null as boolean | null,
		TelfmaNr: null as string | null,
		TelmobNr: null as string | null,
		TelprivNr: null as string | null,
		TympracId: null as number | null,
		Ulice: null as string | null,
		Uvazek: null as number | null,
		PlneJmeno: null as string | null,
		OpravneniNaSklady: [] as string[],
		OpravneniNaSkladyNv: [] as string[],
		OpravneniNaSkladyOv: [] as string[],
		OpravneniNaSkladyOstatni: [] as string[],
		OpravneniNaSkladyPneu: [] as string[],
		OpravneniNaPujcovny: [] as number[],
	},
	OrganizaceData: {
		OrganizaceStatIso2: null as string | null,
		AphlasMimoPrp: null as boolean | null,
		CdbOnlinePrp: null as boolean | null,
		DobropisplatbadleorigPrp: null as boolean | null,
		DokladPfxUnqPrp: null as boolean | null,
		DokladnrStylPzn: null as string | null,
		DsbDmsnovinkyTtlMes: null as number | null,
		DsbDmsnovinkyTtpMes: null as number | null,
		DsbLocalTtlMes: null as number | null,
		DsbLocalTtpMes: null as number | null,
		DsbSmsTtlMes: null as number | null,
		DsbSmsTtpMes: null as number | null,
		DsbSystemTtlMes: null as number | null,
		DsbSystemTtpMes: null as number | null,
		EMailSmtpPrp: null as boolean | null,
		EetPrp: null as boolean | null,
		EetTimeout: null as number | null,
		EmiseMereniNr: null as number | null,
		Emise1MesicInl: null as number | null,
		EmisenextMesicInl: null as number | null,
		EuroStatus: null as boolean | null,
		Firma: null as string | null,
		GdprZakonPlatnost: null as number | null,
		GovregTtlDni: null as number | null,
		KalkdrmatprePzn: null as number | null,
		KalkgarpcndPzn: null as number | null,
		KalkgarpcppPzn: null as number | null,
		KalklakdruhprePzn: null as number | null,
		KalkmetodpokynPrp: null as boolean | null,
		KalknekatalogoveppPrp: null as boolean | null,
		KalkneorigndPrp: null as boolean | null,
		KalkneorigppPrp: null as boolean | null,
		KalkorigtxtndPzn: null as number | null,
		KalkorigtxtppPzn: null as number | null,
		KalkulacePzn: null as number | null,
		KourivInlLmtLex: null as number | null,
		KourivKonLmtLex: null as number | null,
		KurzFixM2: null as number | null,
		KurzstrPar: null as string | null,
		KurzstrSm2pmPar: null as string | null,
		LanguageId: null as number | null,
		M2FixacePrp: null as boolean | null,
		MdvPnvBlokPrp: null as boolean | null,
		PrimarniMena: {
			BezhotovostniZaokrouhleni: null as number | null,
			HotovostniZaokrouhleni: null as number | null,
			MenaId: null as number | null,
			Zkratka: null as string | null,
		},
		SekundarniMena: {
			BezhotovostniZaokrouhleni: null as number | null,
			HotovostniZaokrouhleni: null as number | null,
			MenaId: null as number | null,
			Zkratka: null as string | null,
		},
		MobcliToMi: null as number | null,
		NdakcecheckPzn: null as NDAKCECHECK_PZN | null,
		NvkonfigstylPzn: null as number | null,
		NvnabidkaPldniInl: null as number | null,
		Obec: null as string | null,
		OrganizaceId: null as number | null,
		OzakDniCheckVpred: null as number | null,
		OzakDniCheckVzad: null as number | null,
		PpDuplCheckPrp: null as boolean | null,
		PreberpojistprofilPrp: null as boolean | null,
		PscNr: null as string | null,
		QrCodeRezimPzn: null as boolean | null,
		RyoKratitPrp: null as boolean | null,
		S2RlCjZobrPrp: null as boolean | null,
		S2RlLjZobrPrp: null as boolean | null,
		SkoKratitPrp: null as boolean | null,
		SkozakKratitPrp: null as boolean | null,
		SmBcodePrp: null as boolean | null,
		SmNomslevaPrp: null as boolean | null,
		SnndCheckPrp: null as boolean | null,
		SnppCheckPrp: null as boolean | null,
		Sort2DdSmNd: null as string | null,
		Sort2DdSmPp: null as string | null,
		StatId: null as number | null,
		SysPracovnikId: null as number | null,
		Text: null as string | null,
		Ulice: null as string | null,
		UovPovBlokPrp: null as boolean | null,
		VlozitplannepritPrp: null as boolean | null,
		VlozitplanprestPrp: null as boolean | null,
		VyhodmechHcvPrp: null as boolean | null,
		ZakazDelPoznPrp: null as boolean | null,
		ZlStartpozPrp: null as boolean | null,
		ZlTiskkontrPrp: null as boolean | null,
	},
	PracovnikProvSelect: [] as number[],
	PracovnikProvUpdate: [] as number[],
	DmsSys: {
		AdminCertAlertPrp: null as boolean | null,
		APlusISOVPrp: null as boolean | null,
		ArchivDilnaMesMinus: null as string | number | null,
		ArchivNVMesMinus: null as string | number | null,
		ArchivOVMesMinus: null as string | number | null,
		AutoLoadCentralMessages: null as string | number | null,
		BarcodeMazat: null as string | number | null,
		bmo_vtis: null as string | number | null,
		CasovyRozdil: null as string | number | null,
		CasProHlaseni: null as string | number | null,
		CastDobropisNVKoef: null as string | number | null,
		CastDobropisNVPrp: null as boolean | null,
		CastDobropisOVKoef: null as string | number | null,
		CastDobropisOVPrp: null as boolean | null,
		CastDobropisSMKoef: null as string | number | null,
		CastDobropisSMPrp: null as boolean | null,
		CDBCaptionStatPrp: null as boolean | null,
		CDBCarDescriptionAutoLoad: null as string | number | null,
		CDBDealerCheckPrp: null as boolean | null,
		CDBLog: null as string | number | null,
		CDBMainPrp: null as boolean | null,
		CDBSwitchIBC: null as string | number | null,
		CDBZakaznikOPStatPrp: null as boolean | null,
		CDBZakaznikStatPrp: null as boolean | null,
		CERTUpozorniInl: null as string | number | null,
		CiziVyrNDOznChevy: null as string | number | null,
		CRMHeurisicInMonthINL: null as string | number | null,
		CRMttlNVOfferPrnumbereInDays: null as string | number | null,
		CRMttlNVOfferUnprinInDays: null as string | number | null,
		CRMttlNVOrderInDays: null as string | number | null,
		CRMttlPNVWithoutCarInDays: null as string | number | null,
		CRMttlSMZakazkOpenInDays1: null as string | number | null,
		CRMttlSMZakazkOpenInDays2: null as string | number | null,
		CRMttlVDemandInDays: null as string | number | null,
		DatabVerze: null as string | number | null,
		dlgRepObrat1: null as string | number | null,
		dlgRepObrat2: null as string | number | null,
		dlgRepObrat3: null as string | number | null,
		dlgRepObrat4: null as string | number | null,
		DMSC_AutoPartPrp: null as boolean | null,
		DMSC_url: null as boolean | null,
		DMSDEVInstancePrp: null as boolean | null,
		DMSFuncUtilPrp: null as boolean | null,
		DMSMCOLogMaxZaznamu: null as string | number | null,
		DMS3_auth: null as string | number | null,
		DokladNVServPorPrp: null as boolean | null,
		DoklCRDokladuPredNotif: null as string | number | null,
		DoklDPHZaokr: null as string | number | null,
		DoklDPHZaokrCastka: null as string | number | null,
		DoklDPHZaokrCastkaVrub: null as string | number | null,
		DoklDPHZaokrZpusob: null as string | number | null,
		DoklHalVyrov: null as string | number | null,
		DoklNahrCisRady: null as string | number | null,
		DoklNVSlevaZaokr: null as string | number | null,
		DoklOVSlevaZaokr: null as string | number | null,
		DoklPolozZaokr: null as string | number | null,
		DoklPolozZaokrGar: null as string | number | null,
		DoklPolozZaokrNV: null as string | number | null,
		DoklPolozZaokrOV: null as string | number | null,
		DPHAutoTest: null as string | number | null,
		DPHKalkDPHShorPrcz: null as string | number | null,
		DUZPDatumOpravnyDoklPrp: null as boolean | null,
		DZMKontrola: null as string | number | null,
		EDIGeneratePrp: null as boolean | null,
		EDLNVRTVDataPCGen: null as string | number | null,
		EDLNVRTVDataSOAPLog: null as string | number | null,
		EDLPocetSK: null as string | number | null,
		EmbedovaneDZMPrp: null as boolean | null,
		ESCExtDataSource: null as string | number | null,
		ExportGridDelim: null as string | number | null,
		FISKMODPrp: null as boolean | null,
		fltPNVVINPrp: null as boolean | null,
		GarS2LJKumul: null as string | number | null,
		GATELog: null as string | number | null,
		GDPRTiskRozpZLAnonymPrp: null as boolean | null,
		GovRegPrp: null as boolean | null,
		HEFOVProdejMimoPrp: null as boolean | null,
		HotLine: null as string | number | null,
		HotovostKontoPrp: null as boolean | null,
		HromKorespSDAPrp: null as boolean | null,
		HSStrategy: null as string | number | null,
		CheckStavPujVoz: null as string | number | null,
		ImplValOJBBBID: null as string | number | null,
		ImplValOJBBCountry: null as string | number | null,
		ImplValOJBBParty: null as string | number | null,
		InfoMailPrp: null as boolean | null,
		InfoSMSPrp: null as boolean | null,
		InvMaxSkladMist: null as string | number | null,
		JFNDnumberernValPresentPrp: null as boolean | null,
		JMHASUPrp: null as boolean | null,
		JUOPoradiJmenPrij: null as string | number | null,
		JUOProvozovnaIDPrp: null as boolean | null,
		KDNVDeleteMYsBack: null as string | number | null,
		KOAPPovinPrp: null as boolean | null,
		KOAPPrijmChngPrp: null as boolean | null,
		KorekceDPHZmSazPrp: null as boolean | null,
		KOZLLevel: null as string | number | null,
		KOZLLitePrp: null as boolean | null,
		KOZLPovinPrp: null as boolean | null,
		KOZLPrijmChngPrp: null as boolean | null,
		KulncPCKratitPrp: null as boolean | null,
		MaxClientBuild: null as string | number | null,
		MaxConnections: null as string | number | null,
		MIOLogPrp: null as boolean | null,
		NDAkceDniPredGen: null as string | number | null,
		NDEAN_prp: null as boolean | null,
		NDJFrontaBalJdnSPCPrp: null as boolean | null,
		NDJFrontaVersion1Prp: null as boolean | null,
		NDPCKontrolUvolneni: null as string | number | null,
		NDPCKontrolVydejMAPrp: null as boolean | null,
		NDPrijemkaEDLBlokace_prp: null as boolean | null,
		NDPrijemPCzdolaPrepoc_prp: null as boolean | null,
		NDShodaAdd_prp: null as boolean | null,
		NDSkladAuditERROnlyPrp: null as boolean | null,
		NDSkladOductPNC: null as string | number | null,
		NVDDTiskDatCasPrp: null as boolean | null,
		NVDokladOpravaPrp: null as boolean | null,
		NVGarKonecDefault: null as string | number | null,
		NVKOZLLevel: null as string | number | null,
		NVKOZLPovinPrp: null as boolean | null,
		NVNabVelkooSlevSzbDefPrc: null as string | number | null,
		NVOsobDataSouhl: null as string | number | null,
		NVPoprodPodpKontrSum: null as string | number | null,
		NVPoptavkaOldZobrazPrp: null as boolean | null,
		NVRelokaceNaImporteraPrp: null as boolean | null,
		NVVydejBezPNVPrp: null as boolean | null,
		NVZhodnocNCNezapocti: null as string | number | null,
		NVZhodnocNCNezapocti_Old: null as string | number | null,
		NV2DDNarozeniDatPrp: null as boolean | null,
		OdvozenePPAPOS_VyrVOzn: null as string | number | null,
		OdvozenePPVolne_VyrVOzn: null as string | number | null,
		OnlineUctoPrp: null as boolean | null,
		OVDDTiskDatCasPrp: null as boolean | null,
		OVDokladOpravaPrp: null as boolean | null,
		OVDokladPolPCNullPrp: null as boolean | null,
		OVGarKonecDefault: null as string | number | null,
		OVOdeslPovinPrp: null as boolean | null,
		OV2DDNarozeniDatPrp: null as boolean | null,
		PartnerUliceKonkatPrp: null as boolean | null,
		PersonalCardBarCodeKonv: null as string | number | null,
		PersonalCardTyp: null as string | number | null,
		PChICAPacketsDrMatFakePrp: null as boolean | null,
		PIAfcePrp: null as boolean | null,
		PMClearOrphansPrp: null as boolean | null,
		PMRewriteMailTelPrp: null as boolean | null,
		PNVDocsAGenPrp: null as boolean | null,
		PojistDoklKDC: null as string | number | null,
		PolDobrNDUpozorniInl: null as string | number | null,
		PPOdpisTNSCheckLevel: null as string | number | null,
		PPSOHTMLDebugInfoShowPrp: null as boolean | null,
		PrevodNDSamostDokl: null as string | number | null,
		RPZVPrp: null as boolean | null,
		SAGALog: null as string | number | null,
		SAGA2KulanPodilPrezPrp: null as boolean | null,
		SASOsobDataLogicPrp: null as boolean | null,
		SignoSoftBindStr: null as string | number | null,
		SKLADMISTOPkonv: null as string | number | null,
		SklPNEUProtDocPrp: null as boolean | null,
		SklPNEUPruvodkaOldPrp: null as boolean | null,
		SKODAnumberPrp: null as boolean | null,
		SkrytaSlevaMATPrpSM: null as boolean | null,
		SKSpecificPrp: null as boolean | null,
		SMDDTiskDatCasPrp: null as boolean | null,
		SMDokladOpravaPrp: null as boolean | null,
		SMGarKulTerAlertPrp: null as boolean | null,
		SMGarKulTerZakonLhu: null as string | number | null,
		SMNDNrKVCheckPrp: null as boolean | null,
		SMOsobDataSouhl: null as string | number | null,
		SMSGatewayType: null as string | number | null,
		SMUvolneniCAPNDKontrol: null as string | number | null,
		SMUvolneniCAPPPKontrol: null as string | number | null,
		SM2DDLakGenSTRN_OZNPrp: null as boolean | null,
		SM2DDPPFixniPCSlevaPrp: null as boolean | null,
		SM2DDPPPCStyle: null as string | number | null,
		SNDisponMyProvozPrp: null as boolean | null,
		SNMaxJinePolozkyLimit: null as string | number | null,
		SNPlatnDo_Day: null as string | number | null,
		SNPlatnDo_Mon: null as string | number | null,
		SNPlatnDo_Year: null as string | number | null,
		SupportEmail: null as string | number | null,
		UpdateCommissDateAutoPrp: null as boolean | null,
		UseGlobalUID: null as string | number | null,
		VarSymbolPfxPrp: null as boolean | null,
		VisibleTestReport: null as string | number | null,
		VOZZavadDokladInfoPrp: null as boolean | null,
		VOZZavadZakazOpenPrp: null as boolean | null,
		VOZZavadZakazUvolPrp: null as boolean | null,
		VydejkaNDTrideniStyl: null as string | number | null,
		WEBTaxExpertPrp: null as boolean | null,
		ZakazkaUvolDICTestPrp: null as boolean | null,
		ZakazNDBlokCheckPrp: null as boolean | null,
		ZakazNDRezerCheckPrp: null as boolean | null,
		ZakazOdhCenyRozp: null as string | number | null,
		Zaklist_days: null as string | number | null,
		Zaklist_time_h: null as string | number | null,
		Zaklist_time_m: null as string | number | null,
		Zaklist_time_s: null as string | number | null,
		ZakPlatbaPznNVPrenos: null as string | number | null,
		ZakPlatbaPznOVPrenos: null as string | number | null,
		ZakPlatbaPznSMPrenos: null as string | number | null,
		ZalohaOrezat: null as string | number | null,
		ZCfceNV2DDEmulacePrp: null as boolean | null,
		ZCfcePrp: null as boolean | null,
		ZLBarCodeKonv: null as string | number | null,
		ZLBarCodePrp: null as boolean | null,
		PokladnaPrp: null as boolean | null,
		SplitPrp: null as boolean | null,
		IsActivityEndTimePrp: null as boolean | null,
		GetPartAvailabilityPrp: null as boolean | null,
		IsCommMode_IsDocConf_Prp: null as boolean | null,
		AdvancePaymentPrp: null as boolean | null,
		CustomerRevisitPrp: null as boolean | null,
		DateFilterPrp: null as boolean | null,
		GatePassPrp: null as boolean | null,
		EtdPrp: null as boolean | null,
		ServiceDueDetailsPrp: null as boolean | null,
		Parts_Order_Cancel_Prp: null as boolean | null,
		OrderDiscountPrp: null as boolean | null,
		CustomerFirstPrp: null as boolean | null,
		ServicePackagePrp: null as boolean | null,
		Appointment_2_JobCard_Prp: null as boolean | null,
		WorkItemPrp: null as boolean | null,
		RemarkType_Prp: null as boolean | null,
		WatchlistedApprovalPrp: null as boolean | null,
		ServicPartVisulizationPrp: null as boolean | null,
		VendorCreatePrp: null as boolean | null,
		StorageLocationPrp: null as boolean | null,
		StoreRequisitionFormPrp: null as boolean | null,
		Parts_Enquiry_Prp: null as boolean | null,
		PDITypePrp: null as boolean | null,
		BillingPrp: null as boolean | null,
		SendMailNotificationPrp: null as boolean | null,
		SendSmsNotificationPrp: null as boolean | null,

		IsCancelInvoicePrp: null as boolean | null,
		InventoryAdjustmentPrp: null as boolean | null,
		InventoryDashboardRprtPrp: null as boolean | null,
		CancelOrRescheduleOrdrPrp: null as boolean | null,
		CustomerFeedbackPrp: null as boolean | null,
		GenerateQuotationPrp: null as boolean | null,
		PROrdersPrp: false as boolean | null,
		PROrdersTogglePrp: null as boolean | null,
		SupplierTypePrp: null as boolean | null,
		PrReceiptButtonPrp: null as boolean | null,
		InsurancePolicyPrp: null as boolean | null,
		CustomerOffersDetailsPrp: null as boolean | null,
		AbcFmsAnalysisPrp: null as boolean | null,
		HealthCardPrp: null as boolean | null,
		IndiaCFDPrp: null as boolean | null,
		EnableGSTPrp: null as boolean | null,
		EnableVATPrp: null as boolean | null,
		WarrantyPrp: null as boolean | null,
		Seg_Vin_DiscountPrp: null as boolean | null,
		AfterSalesPrp: null as boolean | null,
		EventFrequencyPrp: null as boolean | null,
		NationalAccountPrp: null as boolean | null,
		EventConfigurationPrp: null as boolean | null,
		CommunicationEventConfigPrp: null as boolean | null,
		EnableTaiwanPrp: null as boolean | null,
		EnableInvestorDealerPrp: null as boolean | null,
		IsAllContractTypePrp: null as boolean | null,
		IsPreparationActivePrp: null as boolean | null,
		EGUISplitPrp: null as boolean | null,
		EnableOldCashierReportPrp: null as boolean | null,
		SendToEdfsPrp: null as boolean | null
	},
	DiscountLimitConfigData: {
		PracovnikId: null as number | null,
		PartItemVal: 0 as number,
		PartItemPer: 0 as number,
		PartItemTotalVal: 0 as number,
		PartItemTotalPer: 0 as number,
		LaborItemVal: 0 as number,
		LaborItemPer: 0 as number,
		LaborItemTotalVal: 0 as number,
		LaborItemTotalPer: 0 as number,
		OrderTotalVal: 0 as number,
		OrderTotalPer: 0 as number,
	},
	UserMenu: null as any | null,
	UserTabs: null as any | null,
	UserRoles: null as any | null,
};


export type LoggedUser = typeof loggedUser;
